import consts from "../../../../shared/consts";
import style from "./widthPicker.module.css";
import { DropdownButton, Icon } from "../toolbar-buttons";
import { ButtonRow } from "./toolbar-design-system";
import ToggleButton from "./toggle-button";

export function WidthPicker({
  value,
  onChange,
  tooltip,
  multi,
}: {
  value: string;
  onChange?: any;
  tooltip?: string;
  multi?: boolean;
}) {
  const subMenu = () => {
    return (
      <ButtonRow>
        <ToggleButton
          isOn={!multi && value === consts.WIDTH_SIZES.LARGE}
          onClick={() => onChange && onChange(consts.WIDTH_SIZES.LARGE)}
          className={style.btn}
        >
          <svg width="16px" height="16px" viewBox="0 0 24 24" fill="currentColor" stroke="none">
            <circle cx="50%" cy="50%" r="50%" />
          </svg>
        </ToggleButton>
        <ToggleButton
          isOn={!multi && value === consts.WIDTH_SIZES.SMALL}
          onClick={() => onChange && onChange(consts.WIDTH_SIZES.SMALL)}
          className={style.btn}
        >
          <svg width="8px" height="8px" viewBox="0 0 24 24" fill="currentColor" stroke="none">
            <circle cx="50%" cy="50%" r="50%" />
          </svg>
        </ToggleButton>
      </ButtonRow>
    );
  };

  return (
    <DropdownButton tooltip={tooltip} className={style.popupContainer} renderPopup={subMenu}>
      <Icon icon="icon-line-thickness" />
    </DropdownButton>
  );
}
